import { FunctionComponent, useMemo } from "react";
import classnames from "classnames";
import { SelectionsBoard } from "../SelectionsBoard/SelectionsBoard.web";
import { SelectionsBoardTheme } from "../SelectionsBoard/SelectionsBoard.types";
import { SystemIconName } from "@ppb/the-wall-icons";

import styles from "./BetLegs.web.css";
import { ComponentProps } from "./props";
import { SelectionHint } from "../SelectionHint/SelectionHint.web";
import { SelectionConnector } from "../SelectionConnector/SelectionConnector.web";
import { getConnectorVariant } from "../../helpers/get-connector-variant";

export const BetLegs: FunctionComponent<ComponentProps> = ({
  legIds,
  legHints,
  title,
  eventName,
  description,
  renderLeg,
  isWarning,
  hasIcon,
  hasSelectionConnector,
  onRemove,
}) => {
  const icon = useMemo(
    () => (isWarning && hasIcon ? SystemIconName.NOTIFICATION_WARNING : undefined),
    [isWarning, hasIcon],
  );

  if (!legIds.length) {
    return null;
  }

  const theme = isWarning ? SelectionsBoardTheme.Yellow : SelectionsBoardTheme.Blue;

  const contentStyle = classnames(styles.selections, isWarning && styles.selectionsWithoutBackground);
  const descriptionStyle = classnames(styles.description, { [styles.warning]: isWarning });
  return (
    <div className={styles.betLegs}>
      <SelectionsBoard title={isWarning ? title : undefined} theme={theme} icon={icon} onRemoveSelection={onRemove}>
        {description?.trim() && <section className={descriptionStyle}>{description}</section>}
        {!isWarning && eventName && <section className={`${styles.description} typography-h120`}>{eventName}</section>}
        <div className={contentStyle}>
          {legHints?.length
            ? legHints.map((group) => {
                const shouldShowSelectionConnector =
                  hasSelectionConnector && !group.hintMessage && group.legIds.length > 1;

                return (
                  <SelectionHint key={group.legIds[0]} hintMessage={group.hintMessage}>
                    {group.legIds.map((legId, index) => (
                      <div key={legId} className={styles.legRow}>
                        {shouldShowSelectionConnector && (
                          <SelectionConnector variant={getConnectorVariant(index, group.legIds.length)} />
                        )}
                        <div className={styles.legContent}>{renderLeg(legId)}</div>
                      </div>
                    ))}
                  </SelectionHint>
                );
              })
            : legIds.map((legId, index) => (
                <div key={legId} className={styles.legRow}>
                  {hasSelectionConnector && legIds.length > 1 && (
                    <SelectionConnector variant={getConnectorVariant(index, legIds.length)} />
                  )}
                  <div className={styles.legContent}>{renderLeg(legId)}</div>
                </div>
              ))}
        </div>
      </SelectionsBoard>
    </div>
  );
};
